export const LogoutModalTranslations = {
  en: {
    logoutModal: {
      title: "Log out?",
      description: "Are you sure you want to log out of your account?",
      cancel: "Cancel",
      confirm: "Log out",
    },
  },
  es: {
    logoutModal: {
      title: "¿Cerrar sesión?",
      description: "¿Estás seguro de que quieres cerrar sesión?",
      cancel: "Cancelar",
      confirm: "Cerrar sesión",
    },
  },
};
